import React from "react";
import { graphql } from "gatsby";
import { PageBuilderVideoSectionFragment } from "types/graphql-types";
import VideoSection from "components/Video/VideoSection";
import PageBuilderSectionTitle from "./PageBuilderSectionTitle";

export type PageBuilderVideoSectionProps = PageBuilderVideoSectionFragment;

const PageBuilderVideoSection: React.FC<PageBuilderVideoSectionProps> = ({
  sectionTitle,
  video
}) => {
  if (!video?.file?.videoId) return null;

  return (
    <React.Fragment>
      <PageBuilderSectionTitle {...sectionTitle} ctaButtons={[]} />
      <VideoSection
        videoId={video?.file.videoId}
        trackingTitle={video?.trackingTitle}
        responsivePoster={video?.posterImage}
      />
    </React.Fragment>
  );
};

export default PageBuilderVideoSection;

export const fragments = graphql`
  fragment PageBuilderVideoSection on SanityVideoSection {
    _key
    sectionTitle {
      ...SectionTitle
    }
    video {
      file {
        videoId
        previewImageUrl
        posterImageDownloadUrl
      }
      posterImage {
        ...ImageWithPreview
      }
      trackingTitle
    }
  }
`;
